<template>
  <div v-bind="disableButton? null : $attrs">
    <template v-if="isPublic">
      <AppTooltip :disabled="!isClickable">
        <template #activator="{ props }">
          <app-button :disabled="disableButton"
                      type="counter"
                      variant="neutral"
                      v-bind="props"
                      @click="$emit($event.type, $event)"
          >
            <app-icon-ds icon="users" size="sm" />
          </app-button>
        </template>
        <div>
          {{$t('common.users.RightsDisplayButton.everyone')}}
        </div>
      </AppTooltip>
    </template>
    <template v-else>
      <AppTooltip :disabled="!isClickable">
        <template #activator="{ props }">
          <app-button :disabled="disableButton"
                      type="counter"
                      variant="neutral"
                      v-bind="props"
          >
            <app-icon-ds icon="user-lock" size="sm" />
            {{ numberOfGroupsAndMembers }}
          </app-button>
        </template>
        <div>
          <template v-if="groups.length > 0">
            <div>{{$t('common.users.RightsDisplayButton.sharedWith')}}</div>
            <ul class="pl-2">
              <li v-for="group in groups" :key="`group-${group.id}`">
                <font-awesome-icon :icon="['fas', 'users']" class="mr-2" />
                {{group.name}}
              </li>
              <li v-for="member in members" :key="`member-${member.id}`">
                <font-awesome-icon :icon="['fas', 'user']" class="mr-2" />
                {{member.fullName}}
              </li>
            </ul>
          </template>
        </div>
      </AppTooltip>
    </template>
  </div>
</template>

<script>
import AppTooltip from '@/common/AppTooltip.vue'

export default {
  name: 'RightsDisplayButton',
  components: {
    AppTooltip,
  },
  props: {
    rights: {
      type: Object,
      required: true,
    },
    block: {
      type: Boolean,
      default: false,
    },
    isClickable: {
      type: Boolean,
      default: true,
    },
    disableButton: {
      type: Boolean,
      default: false,
    },
  },
  // We'll handle events on separate nodes. We don't want to handle events through the div wrapper
  inheritAttrs: false,
  computed: {
    // If we're using the signature with read rights, read is always an object
    // Otherwise it'll be undefined
    hasReadRights () {
      return this.rights.read
    },
    isPublic () {
      if (this.hasReadRights) {
        return this.rights.read.isPublic
      } else {
        return this.rights.isPublic
      }
    },
    numberOfGroupsAndMembers () {
      return this.groups.length + this.members.length
    },
    groups () {
      if (this.hasReadRights) {
        if (this.rights.read.groups.length > 0) {
          return this.rights.read.groups
        }
      } else {
        return this.rights.groups
      }
      return []
    },
    members () {
      if (this.hasReadRights) {
        if (this.rights.read.users.length > 0) {
          return this.rights.read.users
        }
      } else {
        return this.rights.users
      }
      return []
    },
  },
}
</script>
